module.exports = require('./lib/search-query-parser');
